export var DateHelper = {
  getDateObjFromYear: function(year) {
      // return new Date(new Date(0).setFullYear(year));
      return new Date(year, 0, 1);
  },
  getCurrentDateObj: function() {
      // DateHelper.getDateObjFromYear(new Date().getFullYear())
      return DateHelper.getDateObjFromYear(new Date().getFullYear());
  }
};
